import { useToast } from '@bfe/moly';
import classNames from 'clsx';
import { useCopyToClipboard } from 'react-use';
import { shortenAddress } from '@web3/base-utils';
import { useFm } from '@web3/base-hooks';

export type CopyTextProps = {
  text: string;
  showText?: boolean;
  showAll?: boolean;
  reverse?: boolean;
  className?: string;
};

export default function CopyText(props: CopyTextProps) {
  const [state, copyToClipboard] = useCopyToClipboard();
  const fm = useFm();
  const {
    text,
    showText = true,
    showAll = false,
    reverse = false,
    className,
  } = props;
  const { toast, EToastType } = useToast();
  const title = fm('copy_success');
  const handleClick = (e: any) => {
    e.stopPropagation();
    state.noUserInteraction && copyToClipboard(text);
    toast({
      iconType: EToastType.SUCCESS,
      title,
    });
  };
  return (
    <div className="cpoy-wrap">
      <div
        className={classNames([
          'flex items-center gap-2 text-white cursor-pointer',
          reverse && 'flex-row-reverse',
          className,
        ])}
        onClick={(e) => handleClick(e)}
      >
        {showText && <span>{showAll ? text : shortenAddress(text || '')}</span>}
        <i className="moly-iconfont bit-icon_copy text-base text-gray leading-6" />
      </div>
    </div>
  );
}
